export const project = 'tealiummorgan'; // need this for when we dynamically import utils

export const sending = ({ win, data: payload }) => {
	// I clone the payload because utag.link modifies it creating lots of properties
	const clonedPayloadForEventviewer = JSON.parse(JSON.stringify(payload));
	const reportsForEventViewer = [];
	const reportsForNewRelic = [];
	const sender = 'window.utag.link()';

	const utagPromise = new Promise((resolve) => {
		if (win?.utag?.link) {
			resolve();
		} else {
			let attempts = 0;
			const interval = setInterval(() => {
				attempts += 1;
				if (win?.utag?.link) {
					clearInterval(interval);
					resolve();
				} else if (attempts >= 100) {
					clearInterval(interval);
				}
			}, 100);
		}
	});

	utagPromise.then(() => {
		win.utag.link(payload);
	});

	reportsForEventViewer.push(
		new Promise((resolve) => {
			utagPromise.then(() => {
				resolve({
					payload: clonedPayloadForEventviewer,
					name: project,
					sender
				});
			});
		})
	);

	reportsForNewRelic.push(
		new Promise((resolve) => {
			utagPromise.then(() => {
				resolve({
					clientEventName: payload?.tealium_event,
					sender
				});
			});
		})
	);

	return {
		reportsForEventViewer,
		reportsForNewRelic
	};
};
